export default __webpack_public_path__ + "static/media/logo.788da3e9.png";